import React, { RefObject } from 'react';
import { useScrollReveal } from '../../../hooks';
import { SectionHeader } from '../../../sections/ThesisSection/layouts';
import { ANSWERS, TICKET } from '../content';
import { Abacus } from '../figures/Abacus';
import { Band, reveal } from './Band';

export function AskSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });
  return (
    <Band id="how-it-answers">
      <div ref={ref as RefObject<HTMLDivElement>}>
        <SectionHeader
          label="How it answers"
          title="Ask in plain language."
          description="Send the context once with all your questions. Every answer you allow gets a probability."
          isVisible={isVisible}
          labelColor="ink"
        />

        <div className={`oh-context ${reveal(isVisible)}`} style={{ animationDelay: '0.2s' }}>
          <p className="font-mono text-label-sm uppercase text-foreground-muted">Context, read once</p>
          <p className="mt-3 font-display italic text-heading-lg md:text-heading text-foreground-secondary dark:text-white/70 text-balance">“{TICKET}”</p>
        </div>

        <div className="oh-columns oh-answers grid grid-cols-1 lg:grid-cols-3">
          {ANSWERS.map((answer, i) => (
            <div key={answer.kind} className={`oh-answer ${reveal(isVisible)}`} style={{ animationDelay: `${0.3 + i * 0.1}s` }}>
              <p className="oh-answer-q font-body text-body-sm text-foreground-secondary dark:text-white/70">{answer.question}</p>
              <div className="oh-answer-fig">
                <Abacus answer={answer} />
              </div>
              <div className="oh-answer-meta">
                <div className="flex items-center gap-2 text-label font-mono text-foreground-secondary dark:text-white/70">
                  <span className={`oh-kind-dot oh-kind-${answer.kind}`} aria-hidden="true" />
                  {answer.label}
                </div>
                <h3 className="mt-2 font-display text-heading-lg text-foreground">{answer.title}</h3>
                <p className="mt-2 font-body text-body-sm text-foreground-tertiary leading-relaxed">{answer.use}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Band>
  );
}

export default AskSection;
